/* unplugin-vue-components disabled */import { render } from "./routerView.vue?vue&type=template&id=044fa054"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__